import { Injectable } from '@angular/core';
import { printClassName } from '@orgbrain/lib-data';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class UuidService {
  constructor() {
    printClassName(' ---> ', this);
  }

  generateUUID() {
    return uuidv4();
  }

  dateId() {
    return new Date().toISOString();
  }
}
